import { enquiryConstants } from "@/actions/constants/enquiryConstant";
import { failure, request, success } from "@/utils/constants";

export const createEnquiryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enquiryConstants.createEnquiryRequest:
            return {
                ...request,
            };
        case enquiryConstants.createEnquirySuccess:
            return {
                ...success,
                enquiryData: action.payload,
            };
        case enquiryConstants.createEnquiryFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};
export const listEnquiryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enquiryConstants.listEnquiryRequest:
            return {
                ...request,
            };
        case enquiryConstants.listEnquirySuccess:
            return {
                ...success,
                enquiryData: action.payload,
            };
        case enquiryConstants.listEnquiryFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};
export const deleteEnquiryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enquiryConstants.deleteEnquiryRequest:
            return {
                ...request,
            };
        case enquiryConstants.deleteEnquirySuccess:
            return {
                ...success,
                enquiryData: action.payload,
            };
        case enquiryConstants.deleteEnquiryFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};
export const viewEnquiryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enquiryConstants.viewEnquiryRequest:
            return {
                ...request,
            };
        case enquiryConstants.viewEnquirySuccess:
            return {
                ...success,
                enquiryData: action.payload,
            };
        case enquiryConstants.viewEnquiryFailure:
            return {
                ...failure,
            };
        case enquiryConstants.clearViewEnquiry:
            return {};
        default:
            return state;
    }
};
export const updateEnquiryReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enquiryConstants.updateEnquiryRequest:
            return {
                ...request,
            };
        case enquiryConstants.updateEnquirySuccess:
            return {
                ...success,
                enquiryData: action.payload,
            };
        case enquiryConstants.updateEnquiryFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};
